module.exports = __webpack_public_path__ + "static/media/lightning-bolt-weather_200.bf180d85.gif";